require("@/common/modernizr/modernizr");

export default {
  methods: {
    isAvailableCookies() {
      return Modernizr.cookies;
    },
    isAvailableJson() {
      return Modernizr.json;
    },
    isAvailableLocalStorage() {
      return Modernizr.localstorage;
    },
    isAvailableSessionStorage() {
      return Modernizr.sessionstorage;
    },
    isAvailableWebGL() {
      return Modernizr.webgl && this.extraWebGLCheck();
    },
    extraWebGLCheck() {
      //modernizr doesn't have a very robust webGL check so we need another
      //Code taken from https://github.com/mrdoob/three.js/blob/master/examples/js/WebGL.js
      try {
        const CANVAS = document.createElement("canvas");
        return !!(
          window.WebGLRenderingContext &&
          (CANVAS.getContext("webgl") ||
            CANVAS.getContext("experimental-webgl"))
        );
      } catch (e) {
        return false;
      }
    },
  },
};
